// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ListFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.5 72c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8 8-3.589 8-8Zm57 0a2 2 0 0 0-2-2h-47a2 2 0 0 0 0 4h47a2 2 0 0 0 2-2Zm-57-24c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8 8-3.589 8-8Zm57 0a2 2 0 0 0-2-2h-47a2 2 0 0 0 0 4h47a2 2 0 0 0 2-2Zm-57-24c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8 8-3.589 8-8Zm55 2h-47a2 2 0 0 1 0-4h47a2 2 0 0 1 0 4Z"
			fill="currentColor"
		/>
	</svg>
);
export default ListFilled;
